<!-- 情书贺卡商品加购 -->
<template>
  <div>
    <jd-title label='商品加购' type="bold"></jd-title>
    <el-form-item label="商品加购：" class="zindexBox">
      <el-checkbox v-model="localConfig.exposureSwitch" @change="exposureSwitchChange" :disabled="backgroundOpacity"
        :activityData="activityData">
        是否需要情书加礼物的场景
      </el-checkbox>
      <jd-button class="ml8" @click="exposureProducts" :disabled="localConfig.exposureSwitch == false || backgroundOpacity">
        {{
          localConfig.itemListFor.length != ""
            ? "添加商品" + "(" + localConfig.itemListFor.length + "/100" + ")"
            : "添加商品"
        }}
      </jd-button>
      <draggable v-if="localConfig.itemListFor.length > 0" v-model="localConfig.itemListFor" chosen-class="chosen"
        :scroll="true" animation="150" force-fallback="true" @start="isDragging = true" @end="onEnd"
        class="imageDraggable" filter=".unmover">
        <transition-group type="transition">
          <div v-for="(item, index) in localConfig.itemListFor" :key="item.skuId"
            style="display: inline-block; position: relative" class="show_upImg2"
            :class="backgroundOpacity ? 'unmover' : ''">
            <img :src="item.logo" width="120px" height="120px" class="d_ib" />&nbsp;
            <div class="delectPosible" v-if="!backgroundOpacity">
              <span class="delectSort">拖动排序</span>
              <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
            </div>
          </div>
        </transition-group>
      </draggable>
    </el-form-item>

    <!-- 添加曝光商品弹窗 -->
    <selectGoodsMonitor v-if="selectGoodsState" ref="selectGo" :isShow="selectGoodsState" @close="selectGoodsClose"
      :selectGoods="localConfig.itemListFor" :moduleType="true" :skuSearch="true" :xianz="true"
      :disabled="backgroundOpacity" :isLimit="true" :limitNum="100">
    </selectGoodsMonitor>

  </div>
</template>

<script>
import draggable from "vuedraggable";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";

export default {
  name: 'GoodsBuyForm',
  components: {
    draggable,
    selectGoodsMonitor,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    backgroundOpacity: {
      type: Boolean,
      default: false
    },
    activityData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isPremissionShow: true,
      localConfig: this.value,
      isDragging: false, // 是否正在拖拽
      selectGoodsState: false, // 加购商品弹窗
    };
  },
  watch: {
    value: {
      handler(val) {
        this.localConfig = val;
      },
      deep: true
    },
    localConfig: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    },
    permissions:{
      handler(nVal, oVal) {
        if (nVal.indexOf("hide:interactive:product:offline") != "-1") {
         this.isPremissionShow = false;
        }
      },
      immediate: true,
    },
  },
  computed: {
    //权限判断
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
  },
  methods: {
    // 添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.localConfig.itemListFor.length == 0) {
        this.localConfig.itemListFor = [];
      }
      this.$nextTick(() => {
        this.$refs.selectGo.handleRightCurrentChange(1);
      })
    },

    // 加购商品复选框勾选事件
    exposureSwitchChange(val) {
      if (!val) {
        this.localConfig.itemListFor = [];
      }
      this.$forceUpdate();
    },

    // 添加加购商品
    selectGoodsClose(data) {
      if (data) {
        let isGoods = false;
        data.forEach((item) => {
          if (item.skuStatus != 1) {
            isGoods = true;
          }
        });
        if(this.isPremissionShow){
         if (isGoods) {
           return this.$message.warning("当前所选商品包含下架商品，请重新选择");
         }
        }
        console.log(data);
        this.localConfig.itemListFor = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.wareId = data[index].wareId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          fomeVaule.skuStatus = data[index].skuStatus;
          this.localConfig.itemListFor.push(fomeVaule);
        });
      }
      this.selectGoodsState = false;
    },

    // 删除图片
    delec(index) {
      this.localConfig.itemListFor.splice(index, 1);
      this.$forceUpdate();
    },

    // 图片拖拽
    onEnd() {
      this.isDragging = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.imageDraggable {
  margin-top: 10px;
  background: rgba(38, 112, 251, 0.06);
  padding: 10px;
}

.d_ib {
  display: inline-block;
}

.zindexBox {
  position: relative;
  z-index: 1;
}

.add_btn1 {
  cursor: pointer;
  color: #2768ff;
  border: 1px solid #2768ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
</style>